import moment from 'moment';

export const disableDateRange = (range = { startDate: false, endDate: false }) => {
  const { startDate, endDate } = range;
  return (current) => {
    if (current) {
      const currentMoment =  moment(current).startOf('day');
      if (startDate) {
        const startDateZero = moment(startDate).startOf('day');
        const startDiff = currentMoment.diff(startDateZero, 'days');
        if (startDiff < 0) {
          return true; // disable
        }
      }
  
      if (endDate) {
        const endDateZero = moment(endDate).startOf('day');
        const endDiff = currentMoment.diff(endDateZero, 'days');
        if (endDiff > 0) {
          return true; // disable
        }
      }
    }

    return false;
  };
}